import { CtaButton } from "@/components/CtaButton";
import { Reveal, SectionHead, Em } from "@/components/Reveal";
import { books, site } from "@/config/site.config";

export const BooksSection = () => (
  <section data-testid="books-section" className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
    <SectionHead eyebrow="THREE DIGITAL BOOKS INCLUDED" center>
      KEEP THE VISION
      <br />
      WITHIN <Em>REACH.</Em>
    </SectionHead>

    <div className="grid gap-10 sm:grid-cols-3 sm:gap-6" data-testid="books-grid">
      {books.map((b, i) => (
        <Reveal key={b.title} delay={i * 0.1} className={i === 1 ? "sm:-mt-6" : ""}>
          <div className="group">
            <div className="overflow-hidden rounded-xl border border-white/10 shadow-[0_30px_60px_rgba(0,0,0,0.6)] transition-transform duration-500 group-hover:-translate-y-2 group-hover:rotate-[-1deg]">
              <img src={b.img} alt={`${b.title} — digital book by Dasha Love`} loading="lazy" className="block w-full" data-testid={`book-cover-${i + 1}`} />
            </div>
            <p className="mt-5 font-mono text-[10px] tracking-[0.3em] text-lime">BOOK 0{i + 1}</p>
            <h3 className="mt-2 text-xl font-extrabold tracking-tight text-cream">{b.title}</h3>
            <p className="mt-1 font-serif text-base italic text-gold">{b.sub}</p>
            <p className="mt-3 text-sm leading-relaxed text-cream/60">{b.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal className="mx-auto mt-16 max-w-2xl text-center">
      <p className="text-base text-cream/70 sm:text-lg">
        Use the experience when you are ready to go deep. Keep the books nearby when you need to reconnect with
        the vision, your why, or your next move.
      </p>
      <p className="mt-8 font-mono text-xs tracking-[0.3em] text-cream/50">
        THE EXPERIENCE + ALL 3 DIGITAL BOOKS
        <br />
        <span className="text-lime">ONE PAYMENT OF {site.price}</span>
      </p>
      <div className="mt-6">
        <CtaButton id="books">GET THE COMPLETE BUNDLE — {site.price}</CtaButton>
      </div>
    </Reveal>
  </section>
);
